type FederatedRedirectOptions = {
  stage: string
  configuredRedirectUri: string
  currentOrigin: string
}

export const resolveFederatedRedirectUri = ({
  stage,
  configuredRedirectUri,
  currentOrigin,
}: FederatedRedirectOptions): string => {
  return stage === 'prod' ? currentOrigin : configuredRedirectUri
}
